import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { DateFormat } from "@/components/atoms";

type DriverLicenseAndIdProps = {
    details: MyBrokerApi.PersonalDetails;
};

const DriverLicenseAndId: FC<DriverLicenseAndIdProps> = ({ details = {} }) => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.Identity.NationalNumber")}</span>
                <p>{details.identityCard?.nationalNumber || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.Identity.Number")}</span>
                <p>{details.identityCard?.number || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.Identity.ValidFrom")}</span>
                <p>{details.identityCard?.validFrom ? <DateFormat date={details.identityCard?.validFrom} /> : "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.Identity.ValidTo")}</span>
                <p>{details.identityCard?.validTo ? <DateFormat date={details.identityCard?.validTo} /> : "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssuedBy")}</span>
                <p>{details.identityCard?.issuedBy || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Number")}</span>
                <p>{details.driversLicense?.number || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssueDate")}</span>
                <p>
                    {details.driversLicense?.issueDate ? <DateFormat date={details.driversLicense?.issueDate} /> : "-"}
                </p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("Common.Type")}</span>
                <p>{details.driversLicense?.type?.name || "-"}</p>
            </div>
            <div className="infoContainer">
                <span className="label">{t("User.PersonalDetails.DriverLicenseAndId.DriverLicense.IssueCountry")}</span>
                <p>{details.driversLicense?.issueCountry?.name || "-"}</p>
            </div>
        </div>
    );
};

export default DriverLicenseAndId;
